import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import Api from '../../services/api';
import Toast from '../Toast';
import { keyToken } from '../../config';

import { getStorageItem } from '../../helpers/storage';
import { IsSSR } from '../../helpers/isSSR';

import EditModalMedia from './partials/Edit';

const selectedImageStyle = {
  display: 'block',
  border: '3px solid #CC0000',
  borderRadius: '7px',
  width: '100%',
  height: '100%'
};

const unselectedImageStyle = {
  display: 'block',
  width: '100%',
  height: '100%'
};

/*
 * Custom "star" icon for the toolbar using an Octicon
 * https://octicons.github.io
 */
const CustomButton = () => (
  <svg viewBox="0 0 18 18">
    <rect className="ql-stroke" height="10" width="12" x="3" y="4"></rect>
    <circle className="ql-fill" cx="6" cy="7" r="1"></circle>
    <polyline
      className="ql-even ql-fill"
      points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
    ></polyline>
  </svg>
);
/*
 * Custom toolbar component including insertImage button and dropdowns
 */
const CustomToolbar = () => (
  <div id="toolbar">
    <span className="ql-formats">
      <button type="button" className="ql-header" value="1">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-fill"
            d="M1.992,12.728 C1.81066576,12.9093342 1.58966797,13 1.329,13 C1.06833203,13 0.84733424,12.9093342 0.666,12.728 C0.48466576,12.5466658 0.394,12.325668 0.394,12.065 L0.394,1.525 C0.394,1.26433203 0.48466576,1.04333424 0.666,0.862 C0.84733424,0.68066576 1.06833203,0.59 1.329,0.59 C1.58966797,0.59 1.81066576,0.68066576 1.992,0.862 C2.17333424,1.04333424 2.264,1.26433203 2.264,1.525 L2.264,5.503 C2.264,5.60500051 2.31499949,5.656 2.417,5.656 L7.381,5.656 C7.48300051,5.656 7.534,5.60500051 7.534,5.503 L7.534,1.525 C7.534,1.26433203 7.62466576,1.04333424 7.806,0.862 C7.98733424,0.68066576 8.20833203,0.59 8.469,0.59 C8.72966797,0.59 8.95066576,0.68066576 9.132,0.862 C9.31333424,1.04333424 9.404,1.26433203 9.404,1.525 L9.404,12.065 C9.404,12.325668 9.31333424,12.5466658 9.132,12.728 C8.95066576,12.9093342 8.72966797,13 8.469,13 C8.20833203,13 7.98733424,12.9093342 7.806,12.728 C7.62466576,12.5466658 7.534,12.325668 7.534,12.065 L7.534,7.271 C7.534,7.16899949 7.48300051,7.118 7.381,7.118 L2.417,7.118 C2.31499949,7.118 2.264,7.16899949 2.264,7.271 L2.264,12.065 C2.264,12.325668 2.17333424,12.5466658 1.992,12.728 Z M11.42,8.63 C11.3266662,8.7033337 11.2283339,8.7133336 11.125,8.66 C11.0216661,8.6066664 10.97,8.5200006 10.97,8.4 L10.97,7.67 C10.97,7.2899981 11.1233318,6.9900011 11.43,6.77 L12.44,6.03 C12.7400015,5.8099989 13.0833314,5.7 13.47,5.7 L14.1,5.7 C14.2533341,5.7 14.3866661,5.7566661 14.5,5.87 C14.6133339,5.9833339 14.67,6.1166659 14.67,6.27 L14.67,12.43 C14.67,12.5833341 14.6133339,12.7166661 14.5,12.83 C14.3866661,12.9433339 14.2533341,13 14.1,13 L13.47,13 C13.3166659,13 13.1833339,12.9433339 13.07,12.83 C12.9566661,12.7166661 12.9,12.5833341 12.9,12.43 L12.9,7.57 L12.88,7.57 L11.42,8.63 Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-header" value="2">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-fill"
            d="M1.992,12.728 C1.81066576,12.9093342 1.58966797,13 1.329,13 C1.06833203,13 0.84733424,12.9093342 0.666,12.728 C0.48466576,12.5466658 0.394,12.325668 0.394,12.065 L0.394,1.525 C0.394,1.26433203 0.48466576,1.04333424 0.666,0.862 C0.84733424,0.68066576 1.06833203,0.59 1.329,0.59 C1.58966797,0.59 1.81066576,0.68066576 1.992,0.862 C2.17333424,1.04333424 2.264,1.26433203 2.264,1.525 L2.264,5.503 C2.264,5.60500051 2.31499949,5.656 2.417,5.656 L7.381,5.656 C7.48300051,5.656 7.534,5.60500051 7.534,5.503 L7.534,1.525 C7.534,1.26433203 7.62466576,1.04333424 7.806,0.862 C7.98733424,0.68066576 8.20833203,0.59 8.469,0.59 C8.72966797,0.59 8.95066576,0.68066576 9.132,0.862 C9.31333424,1.04333424 9.404,1.26433203 9.404,1.525 L9.404,12.065 C9.404,12.325668 9.31333424,12.5466658 9.132,12.728 C8.95066576,12.9093342 8.72966797,13 8.469,13 C8.20833203,13 7.98733424,12.9093342 7.806,12.728 C7.62466576,12.5466658 7.534,12.325668 7.534,12.065 L7.534,7.271 C7.534,7.16899949 7.48300051,7.118 7.381,7.118 L2.417,7.118 C2.31499949,7.118 2.264,7.16899949 2.264,7.271 L2.264,12.065 C2.264,12.325668 2.17333424,12.5466658 1.992,12.728 Z M11.35,13 C11.1966659,13 11.0633339,12.9433339 10.95,12.83 C10.8366661,12.7166661 10.78,12.5833341 10.78,12.43 L10.78,12.2 C10.78,11.8266648 10.9299985,11.5233345 11.23,11.29 C12.3500056,10.4099956 13.0916649,9.7400023 13.455,9.28 C13.8183351,8.8199977 14,8.3700022 14,7.93 C14,7.3166636 13.6600034,7.01 12.98,7.01 C12.5666646,7.01 12.060003,7.1233322 11.46,7.35 C11.3333327,7.3966669 11.2133339,7.3833337 11.1,7.31 C10.9866661,7.2366663 10.93,7.133334 10.93,7 L10.93,6.58 C10.93,6.4066658 10.9799995,6.25166735 11.08,6.115 C11.1800005,5.97833265 11.3133325,5.8866669 11.48,5.84 C12.0866697,5.6799992 12.6699972,5.6 13.23,5.6 C14.0366707,5.6 14.6583312,5.79166475 15.095,6.175 C15.5316688,6.55833525 15.75,7.0899966 15.75,7.77 C15.75,8.3566696 15.5650018,8.91499735 15.195,9.445 C14.8249981,9.97500265 14.1033387,10.6933288 13.03,11.6 C13.0233333,11.6066667 13.02,11.6133333 13.02,11.62 C13.02,11.6266667 13.0233333,11.63 13.03,11.63 L15.22,11.63 C15.3733341,11.63 15.5049995,11.6866661 15.615,11.8 C15.7250006,11.9133339 15.78,12.0466659 15.78,12.2 L15.78,12.43 C15.78,12.5833341 15.7250006,12.7166661 15.615,12.83 C15.5049995,12.9433339 15.3733341,13 15.22,13 L11.35,13 Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-header" value="3">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-fill"
            d="M1.992,12.728 C1.81066576,12.9093342 1.58966797,13 1.329,13 C1.06833203,13 0.84733424,12.9093342 0.666,12.728 C0.48466576,12.5466658 0.394,12.325668 0.394,12.065 L0.394,1.525 C0.394,1.26433203 0.48466576,1.04333424 0.666,0.862 C0.84733424,0.68066576 1.06833203,0.59 1.329,0.59 C1.58966797,0.59 1.81066576,0.68066576 1.992,0.862 C2.17333424,1.04333424 2.264,1.26433203 2.264,1.525 L2.264,5.503 C2.264,5.60500051 2.31499949,5.656 2.417,5.656 L7.381,5.656 C7.48300051,5.656 7.534,5.60500051 7.534,5.503 L7.534,1.525 C7.534,1.26433203 7.62466576,1.04333424 7.806,0.862 C7.98733424,0.68066576 8.20833203,0.59 8.469,0.59 C8.72966797,0.59 8.95066576,0.68066576 9.132,0.862 C9.31333424,1.04333424 9.404,1.26433203 9.404,1.525 L9.404,12.065 C9.404,12.325668 9.31333424,12.5466658 9.132,12.728 C8.95066576,12.9093342 8.72966797,13 8.469,13 C8.20833203,13 7.98733424,12.9093342 7.806,12.728 C7.62466576,12.5466658 7.534,12.325668 7.534,12.065 L7.534,7.271 C7.534,7.16899949 7.48300051,7.118 7.381,7.118 L2.417,7.118 C2.31499949,7.118 2.264,7.16899949 2.264,7.271 L2.264,12.065 C2.264,12.325668 2.17333424,12.5466658 1.992,12.728 Z M11.32,7.07 C11.1666659,7.07 11.0333339,7.0133339 10.92,6.9 C10.8066661,6.7866661 10.75,6.6533341 10.75,6.5 L10.75,6.27 C10.75,6.1166659 10.8066661,5.9833339 10.92,5.87 C11.0333339,5.7566661 11.1666659,5.7 11.32,5.7 L15.05,5.7 C15.2033341,5.7 15.3366661,5.7566661 15.45,5.87 C15.5633339,5.9833339 15.62,6.1166659 15.62,6.27 L15.62,6.5 C15.62,6.8800019 15.4733348,7.1899988 15.18,7.43 L13.67,8.68 L13.67,8.69 C13.67,8.6966667 13.6733333,8.7 13.68,8.7 L13.8,8.7 C14.3800029,8.7 14.8449983,8.8799982 15.195,9.24 C15.5450018,9.6000018 15.72,10.0866636 15.72,10.7 C15.72,11.4733372 15.4833357,12.0666646 15.01,12.48 C14.5366643,12.8933354 13.8566711,13.1 12.97,13.1 C12.436664,13.1 11.8966694,13.0366673 11.35,12.91 C11.1899992,12.8699998 11.0583339,12.7816674 10.955,12.645 C10.8516662,12.5083327 10.8,12.3533342 10.8,12.18 L10.8,11.84 C10.8,11.706666 10.8549995,11.6016671 10.965,11.525 C11.0750006,11.448333 11.196666,11.4299998 11.33,11.47 C11.9033362,11.6566676 12.4033312,11.75 12.83,11.75 C13.2166686,11.75 13.5166656,11.6600009 13.73,11.48 C13.9433344,11.2999991 14.05,11.0500016 14.05,10.73 C14.05,10.4033317 13.9266679,10.173334 13.68,10.04 C13.4333321,9.906666 12.9733367,9.8366667 12.3,9.83 C12.1466659,9.83 12.0133339,9.77500055 11.9,9.665 C11.7866661,9.55499945 11.73,9.4233341 11.73,9.27 L11.73,9.25 C11.73,8.8766648 11.8733319,8.5666679 12.16,8.32 L13.58,7.09 L13.58,7.08 C13.58,7.0733333 13.5766667,7.07 13.57,7.07 L11.32,7.07 Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-header" value="4">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-fill"
            d="M1.992,12.728 C1.81066576,12.9093342 1.58966797,13 1.329,13 C1.06833203,13 0.84733424,12.9093342 0.666,12.728 C0.48466576,12.5466658 0.394,12.325668 0.394,12.065 L0.394,1.525 C0.394,1.26433203 0.48466576,1.04333424 0.666,0.862 C0.84733424,0.68066576 1.06833203,0.59 1.329,0.59 C1.58966797,0.59 1.81066576,0.68066576 1.992,0.862 C2.17333424,1.04333424 2.264,1.26433203 2.264,1.525 L2.264,5.503 C2.264,5.60500051 2.31499949,5.656 2.417,5.656 L7.381,5.656 C7.48300051,5.656 7.534,5.60500051 7.534,5.503 L7.534,1.525 C7.534,1.26433203 7.62466576,1.04333424 7.806,0.862 C7.98733424,0.68066576 8.20833203,0.59 8.469,0.59 C8.72966797,0.59 8.95066576,0.68066576 9.132,0.862 C9.31333424,1.04333424 9.404,1.26433203 9.404,1.525 L9.404,12.065 C9.404,12.325668 9.31333424,12.5466658 9.132,12.728 C8.95066576,12.9093342 8.72966797,13 8.469,13 C8.20833203,13 7.98733424,12.9093342 7.806,12.728 C7.62466576,12.5466658 7.534,12.325668 7.534,12.065 L7.534,7.271 C7.534,7.16899949 7.48300051,7.118 7.381,7.118 L2.417,7.118 C2.31499949,7.118 2.264,7.16899949 2.264,7.271 L2.264,12.065 C2.264,12.325668 2.17333424,12.5466658 1.992,12.728 Z M11.62,10.25 L11.62,10.26 C11.62,10.2666667 11.6233333,10.27 11.63,10.27 L13.28,10.27 C13.3400003,10.27 13.37,10.2433336 13.37,10.19 L13.37,7.77 C13.37,7.7633333 13.3666667,7.76 13.36,7.76 C13.3466666,7.76 13.34,7.7633333 13.34,7.77 L11.62,10.25 Z M10.68,11.6 C10.5266659,11.6 10.3950005,11.5433339 10.285,11.43 C10.1749995,11.3166661 10.12,11.1833341 10.12,11.03 L10.12,10.84 C10.12,10.4666648 10.2299989,10.1233349 10.45,9.81 L13.04,6.16 C13.2600011,5.8533318 13.5566648,5.7 13.93,5.7 L14.43,5.7 C14.5833341,5.7 14.7149994,5.7566661 14.825,5.87 C14.9350006,5.9833339 14.99,6.1166659 14.99,6.27 L14.99,10.19 C14.99,10.2433336 15.0199997,10.27 15.08,10.27 L15.48,10.27 C15.6333341,10.27 15.7666661,10.3266661 15.88,10.44 C15.9933339,10.5533339 16.05,10.6866659 16.05,10.84 L16.05,11.03 C16.05,11.1833341 15.9933339,11.3166661 15.88,11.43 C15.7666661,11.5433339 15.6333341,11.6 15.48,11.6 L15.08,11.6 C15.0199997,11.6 14.99,11.6299997 14.99,11.69 L14.99,12.43 C14.99,12.5833341 14.9350006,12.7166661 14.825,12.83 C14.7149994,12.9433339 14.5833341,13 14.43,13 L13.93,13 C13.7766659,13 13.6450005,12.9433339 13.535,12.83 C13.4249995,12.7166661 13.37,12.5833341 13.37,12.43 L13.37,11.69 C13.37,11.6299997 13.3400003,11.6 13.28,11.6 L10.68,11.6 Z"
          ></path>
        </svg>
      </button>
      <select
        className="ql-font"
        defaultValue={''}
        onChange={(e) => e.persist()}
      >
        <option></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
    </span>
    <span className="ql-formats">
      <select
        className="ql-size"
        defaultValue={''}
        onChange={(e) => e.persist()}
      >
        <option value="small"></option>
        <option></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
    </span>
    <span className="ql-formats">
      <select className="ql-align">
        <option></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-bold">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-stroke"
            d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"
          ></path>
          <path
            className="ql-stroke"
            d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-italic">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="7" x2="13" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="5" x2="11" y1="14" y2="14"></line>
          <line className="ql-stroke" x1="8" x2="10" y1="14" y2="4"></line>
        </svg>
      </button>
      <button type="button" className="ql-underline">
        <svg viewBox="0 0 18 18">
          <path
            className="ql-stroke"
            d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"
          ></path>
          <rect
            className="ql-fill"
            height="1"
            rx="0.5"
            ry="0.5"
            width="12"
            x="3"
            y="15"
          ></rect>
        </svg>
      </button>
      <button type="button" className="ql-strike">
        <svg viewBox="0 0 18 18">
          <line
            className="ql-stroke ql-thin"
            x1="15.5"
            x2="2.5"
            y1="8.5"
            y2="9.5"
          ></line>
          <path
            className="ql-fill"
            d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"
          ></path>
          <path
            className="ql-fill"
            d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-blockquote">
        <svg viewBox="0 0 18 18">
          <rect
            className="ql-fill ql-stroke"
            height="3"
            width="3"
            x="4"
            y="5"
          ></rect>
          <rect
            className="ql-fill ql-stroke"
            height="3"
            width="3"
            x="11"
            y="5"
          ></rect>
          <path
            className="ql-even ql-fill ql-stroke"
            d="M7,8c0,4.031-3,5-3,5"
          ></path>
          <path
            className="ql-even ql-fill ql-stroke"
            d="M14,8c0,4.031-3,5-3,5"
          ></path>
        </svg>
      </button>
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-list" value="ordered">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>
          <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>
          <line
            className="ql-stroke ql-thin"
            x1="2.5"
            x2="4.5"
            y1="5.5"
            y2="5.5"
          ></line>
          <path
            className="ql-fill"
            d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
          ></path>
          <path
            className="ql-stroke ql-thin"
            d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
          ></path>
          <path
            className="ql-stroke ql-thin"
            d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-list" value="bullet">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>
          <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>
          <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>
          <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>
        </svg>
      </button>
      <button type="button" className="ql-indent" value="-1">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="3" x2="15" y1="14" y2="14"></line>
          <line className="ql-stroke" x1="3" x2="15" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="9" x2="15" y1="9" y2="9"></line>
          <polyline className="ql-stroke" points="5 7 5 11 3 9 5 7"></polyline>
        </svg>
      </button>
      <button type="button" className="ql-indent" value="+1">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="3" x2="15" y1="14" y2="14"></line>
          <line className="ql-stroke" x1="3" x2="15" y1="4" y2="4"></line>
          <line className="ql-stroke" x1="9" x2="15" y1="9" y2="9"></line>
          <polyline
            className="ql-fill ql-stroke"
            points="3 7 3 11 5 9 3 7"
          ></polyline>
        </svg>
      </button>
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-link">
        <svg viewBox="0 0 18 18">
          <line className="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>
          <path
            className="ql-even ql-stroke"
            d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
          ></path>
          <path
            className="ql-even ql-stroke"
            d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
          ></path>
        </svg>
      </button>
      <button type="button" className="ql-video">
        <svg viewBox="0 0 18 18">
          <rect className="ql-stroke" height="12" width="12" x="3" y="3"></rect>
          <rect className="ql-fill" height="12" width="1" x="5" y="3"></rect>
          <rect className="ql-fill" height="12" width="1" x="12" y="3"></rect>
          <rect className="ql-fill" height="2" width="8" x="5" y="8"></rect>
          <rect className="ql-fill" height="1" width="3" x="3" y="5"></rect>
          <rect className="ql-fill" height="1" width="3" x="3" y="7"></rect>
          <rect className="ql-fill" height="1" width="3" x="3" y="10"></rect>
          <rect className="ql-fill" height="1" width="3" x="3" y="12"></rect>
          <rect className="ql-fill" height="1" width="3" x="12" y="5"></rect>
          <rect className="ql-fill" height="1" width="3" x="12" y="7"></rect>
          <rect className="ql-fill" height="1" width="3" x="12" y="10"></rect>
          <rect className="ql-fill" height="1" width="3" x="12" y="12"></rect>
        </svg>
      </button>
    </span>

    <span className="ql-formats">
      <button type="button" className="ql-clean">
        <svg className="" viewBox="0 0 18 18">
          <line className="ql-stroke" x1="5" x2="13" y1="3" y2="3"></line>
          <line className="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"></line>
          <line className="ql-stroke" x1="11" x2="15" y1="11" y2="15"></line>
          <line className="ql-stroke" x1="15" x2="11" y1="11" y2="15"></line>
          <rect
            className="ql-fill"
            height="1"
            rx="0.5"
            ry="0.5"
            width="7"
            x="2"
            y="14"
          ></rect>
        </svg>
      </button>
    </span>
    <button className="ql-insertImage">
      <CustomButton />
    </button>
  </div>
);

// class AudioBlot extends BlockEmbed {
//     static create(url) {
//         let node = super.create();
//         node.setAttribute('src', url);
//         node.setAttribute('controls', '');
//         return node;
//     }

//     static value(node) {
//         return node.getAttribute('src');
//     }
// }
// AudioBlot.blotName = 'audio';
// AudioBlot.tagName = 'audio';

class ReactQuillWithImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      caption: '',
      keyword: '',
      medias: [],
      pagination: {
        total_found: 1,
        limit: 9,
        current_page: 1,
        total_page: 1
      },
      loading: false,
      selectedImage: null,
      urlMedia: '',
      type: '',
      name: '',
      addImagePostModal: false,
      quill: null,
      first_page: 1,
      current_page: 1,
      offset: 4,
      quillSelection: null,
      selectedImageEdit: null
    };
    this.isSSR = IsSSR();
    this.token = null;
    if (!this.isSSR) this.token = getStorageItem(keyToken);

    this.toggleAddImagePostModal = this.toggleAddImagePostModal.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleSubmitImage = this.handleSubmitImage.bind(this);
    this.onChangeKeyword = this.onChangeKeyword.bind(this);
    this.getImagePosts = this.getImagePosts.bind(this);
    this.onChangeCaptionUpdate = this.onChangeCaptionUpdate.bind(this);
    this.onChangeMetaTag = this.onChangeMetaTag.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.setSelectedImage = this.setSelectedImage.bind(this);
    this.onChangeCaptionUpdateImage =
      this.onChangeCaptionUpdateImage.bind(this);

    const _ = this;
    this.modules = {
      toolbar: {
        container: '#toolbar',
        handlers: {
          insertImage: function () {
            _.setState({
              quill: this.quill,
              selectedImage: null,
              quillSelection: this.quill.getSelection()
            });
            _.toggleAddImagePostModal();
          }
        }
      },
      clipboard: {
        matchVisual: false
      }
    };

    this.formats = [
      'header',
      'font',
      'size',
      'bold',
      'italic',
      'underline',
      'strike',
      'blockquote',
      'list',
      'bullet',
      'indent',
      'link',
      'video',
      'audio',
      'align',
      'image'
    ];

    if (!this.isSSR) this.ReactQuill = require('react-quill');
  }

  /*
   * Event handler to be attached using Quill toolbar module (see line 73)
   * https://quilljs.com/docs/modules/toolbar/
   * */

  insertImage() {}

  onChangeKeyword(e) {
    const { name, value } = e.target;
    this.setState({ keyword: value });
  }

  toggleAddImagePostModal() {
    if (!this.state.addImagePostModal) {
      this.getImagePosts();
    }
    this.setState({
      addImagePostModal: !this.state.addImagePostModal
    });
  }

  getImagePosts(page = 1, limit = 9) {
    this.setState({ loading: true });
    const route =
      `/media/index?page=` +
      page +
      `&limit=` +
      limit +
      `&keyword=` +
      this.state.keyword;
    Api.get(route, this.token)
      .then((response) => {
        if (response.status && response.status === 'success') {
          this.setState({
            medias: response.data,
            pagination: response.pagination,
            loading: false
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        Toast('Error internet connection');
      });
  }

  pagesNumbers() {
    let from = this.state.pagination.current_page - this.state.offset;
    if (from < 1) {
      from = 1;
    }
    let to = from + this.state.offset * 2;
    if (to >= this.state.pagination.total_page) {
      to = this.state.pagination.total_page;
    }
    let pagesArray = [];
    for (let page = from; page <= to; page++) {
      pagesArray.push(page);
    }
    return pagesArray;
  }

  pageList() {
    return this.pagesNumbers().map((page) => {
      return (
        <a
          href="javascript:void(0);"
          key={page}
          style={{ cursor: 'pointer' }}
          className={`pagination__page ${
            page === this.state.pagination.current_page
              ? 'pagination__page--current'
              : null
          }`}
          onClick={() => this.getImagePosts(page)}
        >
          {page}
        </a>
      );
    });
  }

  handleSelected(id, urlMedia, type, name, caption, media) {
    this.setState({
      urlMedia: urlMedia,
      selectedImage: id,
      type: type,
      name: name,
      caption: caption,
      selectedImageEdit: media
    });
  }

  handleSubmitImage() {
    if (this.state.quillSelection) {
      let cursorPosition = this.state.quillSelection.index;
      if (this.state.type === 'image') {
        this.state.quill.insertEmbed(
          cursorPosition,
          'image',
          {
            alt: this.state.caption,
            url: this.state.urlMedia,
            title: this.state.name
          },
          'user'
        );
      } else if (this.state.type === 'video') {
        this.state.quill.insertEmbed(
          cursorPosition,
          'video',
          this.state.urlMedia,
          'user'
        );
      } else if (this.state.type === 'audio') {
        this.state.quill.insertEmbed(
          cursorPosition,
          'audio',
          this.state.urlMedia,
          'user'
        );
      } else {
        this.state.quill.insertText(
          cursorPosition,
          this.state.name,
          'link',
          this.state.urlMedia
        );
        cursorPosition += this.state.name.length;
      }
      if (this.state.caption) {
        this.state.quill.insertText(
          cursorPosition + 1,
          this.state.caption,
          { size: 'small' },
          'silent'
        );
        cursorPosition += this.state.caption.length + 1;
      }
      this.state.quill.setSelection(cursorPosition + 1);
      this.toggleAddImagePostModal();
    } else {
      this.toggleAddImagePostModal();
    }
  }

  onChangeMetaTag(e) {
    const { name, value } = e.target;
    let { selectedImageEdit } = this.state;
    selectedImageEdit['meta_tag'] = value;
    this.setState({ selectedImageEdit });
  }

  onChangeCaptionUpdate(e) {
    const { name, value } = e.target;
    let { selectedImageEdit } = this.state;
    selectedImageEdit['caption'] = value;
    this.setState({ selectedImageEdit });
  }

  onChangeCaptionUpdateImage(value) {
    const { selectedImageEdit, selectedImage } = this.state;
    if (
      selectedImageEdit &&
      selectedImage &&
      selectedImageEdit.id == selectedImage
    ) {
      this.setState({ caption: selectedImageEdit.caption });
    }
  }

  setLoading(value) {
    this.setState({ loading: value });
  }

  setSelectedImage(value) {
    this.setState({ selectedImageEdit: value });
  }

  render() {
    const ReactQuill = this.ReactQuill;

    if (!this.isSSR && ReactQuill) {
      const Quill = ReactQuill.Quill;
      const BlockEmbed = Quill.import('blots/block/embed');
      class AudioBlot extends BlockEmbed {
        static create(url) {
          let node = super.create();
          node.setAttribute('src', url);
          node.setAttribute('controls', '');
          return node;
        }

        static value(node) {
          return node.getAttribute('src');
        }
      }
      AudioBlot.blotName = 'audio';
      AudioBlot.tagName = 'audio';
      Quill.register(AudioBlot);

      class ImageBlot extends BlockEmbed {
        static create(value) {
          let node = super.create();
          node.setAttribute('alt', value.alt);
          node.setAttribute('src', value.url);
          node.setAttribute('title', value.title);
          return node;
        }

        static value(node) {
          return {
            alt: node.getAttribute('alt'),
            url: node.getAttribute('src'),
            title: node.getAttribute('title')
          };
        }
      }
      ImageBlot.blotName = 'image';
      ImageBlot.tagName = 'img';

      Quill.register(ImageBlot);

      const { medias, selectedImage, loading } = this.state;
      let mediasContainer = medias.map((media) => {
        if (media.media_type === 'image') {
          return (
            <div
              key={'media-' + media.id}
              className="col-md-4 col-6  ivoox-media-img"
              style={{ height: '128px' }}
              title={media.meta_tag}
            >
              <a
                href="javascript:void(0);"
                onClick={() =>
                  this.handleSelected(
                    media.id,
                    media.url,
                    media.media_type,
                    media.meta_tag,
                    media.caption,
                    media
                  )
                }
                style={
                  selectedImage && selectedImage === media.id
                    ? selectedImageStyle
                    : unselectedImageStyle
                }
              >
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${media.url}`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                  }}
                ></div>
              </a>
            </div>
          );
        } else {
          return (
            <div
              key={'media-' + media.id}
              className="col-md-4 col-6  ivoox-media-img"
              style={{ height: '128px' }}
              title={media.meta_tag}
            >
              <a
                href="javascript:void(0);"
                onClick={() =>
                  this.handleSelected(
                    media.id,
                    media.url,
                    media.media_type,
                    media.meta_tag,
                    media.caption,
                    media
                  )
                }
                style={
                  selectedImage && selectedImage === media.id
                    ? selectedImageStyle
                    : unselectedImageStyle
                }
              >
                <div
                  style={{ height: '100%', width: '100%', textAlign: 'center' }}
                >
                  <i
                    className="fa fa-file"
                    aria-hidden="true"
                    style={{
                      fontSize: '50px',
                      marginTop: '15px',
                      display: 'block'
                    }}
                  ></i>
                  <span
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      height: '68px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {media.file_type}
                  </span>
                </div>
              </a>
            </div>
          );
        }
      });
      return (
        <div>
          <Modal
            size="md"
            isOpen={this.state.addImagePostModal}
            toggle={() => this.toggleAddImagePostModal()}
            className="modal-image-custome"
          >
            <ModalHeader toggle={() => this.toggleAddImagePostModal()}>
              Images
            </ModalHeader>
            <ModalBody>
              <LoadingOverlay active={loading} spinner text="Please Wait...">
                <div className="row">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-lg-12 col-12">
                        <div className="col-lg-12 col-12 p-0">
                          <input
                            id="keyword"
                            name="keyword"
                            type="text"
                            placeholder="Search media"
                            className="nav__search-input"
                            value={this.state.keyword}
                            onChange={this.onChangeKeyword}
                          />
                          <button
                            type="button"
                            className="search-button btn btn-md btn-color btn-button"
                            onClick={() => this.getImagePosts(1)}
                          >
                            <i className="ui-search nav__search-icon"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row ivoox-media">{mediasContainer}</div>
                    {medias && medias.length > 0 && (
                      <nav className="pagination">
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            1 === this.state.pagination.current_page
                              ? null
                              : this.getImagePosts(
                                  this.state.pagination.current_page - 1
                                )
                          }
                          style={{
                            cursor:
                              1 === this.state.pagination.current_page
                                ? 'not-allowed'
                                : 'pointer'
                          }}
                          className="pagination__page pagination__icon pagination__page--next"
                        >
                          <i className="ui-arrow-left" />
                        </a>
                        {this.pageList()}
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            this.state.pagination.total_page ===
                            this.state.pagination.current_page
                              ? null
                              : this.getImagePosts(
                                  this.state.pagination.current_page + 1
                                )
                          }
                          style={{
                            cursor:
                              this.state.pagination.total_page ===
                              this.state.pagination.current_page
                                ? 'not-allowed'
                                : 'pointer'
                          }}
                          className="pagination__page pagination__icon pagination__page--next"
                        >
                          <i className="ui-arrow-right" />
                        </a>
                      </nav>
                    )}
                  </div>
                  {this.state.selectedImageEdit && (
                    <EditModalMedia
                      selectedMedia={this.state.selectedImageEdit}
                      onChangeMetaTag={this.onChangeMetaTag}
                      onChangeCaptionUpdate={this.onChangeCaptionUpdate}
                      refreshMedias={this.getImagePosts}
                      setLoading={this.setLoading}
                      setSelectedImage={this.setSelectedImage}
                      onChangeCaptionUpdateImage={
                        this.onChangeCaptionUpdateImage
                      }
                    />
                  )}
                </div>
              </LoadingOverlay>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => this.handleSubmitImage()}>
                Select
              </Button>{' '}
              <Button
                color="secondary"
                onClick={() => this.toggleAddImagePostModal()}
              >
                Batalkan
              </Button>
            </ModalFooter>
          </Modal>
          <CustomToolbar />
          <ReactQuill
            name={this.props.name}
            value={this.props.value}
            onChange={this.props.handleChange}
            modules={this.modules}
            formats={this.formats}
            toggleAddImagePostModal={this.toggleAddImagePostModal}
            theme={'snow'} // pass false to use minimal theme
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default ReactQuillWithImage;
